import request from '@/utils/request'

/** 获取用户列表 */
export function getUserList(data) {
  return request({
    url: 'user/SearchUser',
    method: 'post',
    data
  })
}

/** 添加用户 */
export function addUser(data) {
  return request({
    url: 'user/addUser',
    method: 'post',
    data
  })
}

/** 编辑用户 */
export function editUser(data) {
  return request({
    url: 'user/editUser',
    method: 'post',
    data
  })
}

/** 删除用户 */
export function deleteUser(data) {
  return request({
    url: 'user/deleteUser',
    method: 'post',
    data
  })
}

/** 批量删除用户 */
export function batchDeleteUser(data) {
  return request({
    url: 'user/batchDeleteUser',
    method: 'post',
    data
  })
}

/** 获取用户信息 详情 */
export function getUserDetail(data) {
  return request({
    url: 'user/getUserDetail',
    method: 'post',
    data
  })
}

/** 修改密码 */
export function changeUserPassword(data) {
  return request({
    url: 'user/changeUserPassword',
    method: 'post',
    data
  })
}

/** 数据授权 */
export function userElevatorPermission(data) {
  return request({
    url: 'user/userElevatorPermission',
    method: 'post',
    data
  })
}

/** 获取用户已经授权的数据 */
export function getUserPermissionData(data) {
  return request({
    url: 'user/getUserPermissionData',
    method: 'post',
    data
  })
}

